/* eslint-disable import/prefer-default-export */
import {
  SET_LAST_VERIFICATION_DATE,
  SET_VERIFICATION_ERROR,
} from '../constants';

export function setLastVerificationDate() {
  return {
    type: SET_LAST_VERIFICATION_DATE,
    payload: {
      date: Date.now(),
    },
  };
}

export function setVerificationError(error) {
	return {
		type: SET_VERIFICATION_ERROR,
		payload: {
			error,
		},
	};
}



// WEBPACK FOOTER //
// ./src/actions/lastVerification.js